module.exports = __webpack_public_path__ + "img/mask-oval.f126e4a3.svg";